

export const createUrlFromBlob = (blob?: Blob) => {
  let url
  if (blob) {
    url = URL.createObjectURL(blob)
  }
  return {
    url,
    revokeObjectURL: () => {
      url && URL.revokeObjectURL(url)
    },
  }
}

export const downloadFileFromUrl = (data: ReturnType<typeof createUrlFromBlob>, name?: string) => {
  if (data.url) {
    const a = document.createElement('a')
    a.href = data.url
    a.download = name || `${+new Date()}`
    a.style.display = 'none'
    a.style.visibility = 'hidden'
    a.style.opacity = '0'
    document.body.appendChild(a)
    a.click()
    setTimeout(() => {
      data.revokeObjectURL()
      document.body.removeChild(a)
    }, 0)
  }
}

export const downloadFile = (blob?:Blob, name?:string):void => {
  downloadFileFromUrl(createUrlFromBlob(blob), name)
}

export const hashcode = (str: string | undefined) => {
  if (!str) return undefined
  let hash = 5381
  let i = str.length
  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i)
  }
  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return `${hash >>> 0}`
}
